<div>
<div class="heading">
    Bank Details
</div>

<p class="secondary-text">Provide details of your salary bank account or your principal business account.<br>
    Your loan will be disbursed in this account and EMI will be recovered from the same account. Please ensure you have 3 cheques available for this account at the time of disbursal.
</p>

<mat-tab-group (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="Search bank by IFSC">
        <app-bank-details-by-ifsc [bankAccount]="bankAccount"></app-bank-details-by-ifsc>
    </mat-tab>
    <mat-tab label="Search IFSC by bank">
        <app-bank-details-by-name [bankAccount]="bankAccount"></app-bank-details-by-name>
    </mat-tab>
</mat-tab-group>

<div class="row">
    <div class="col-xs-6">
        <button mat-stroked-button class="button-back primary" type="button" (click)="previousPage()">
            <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
        </button>
    </div>
    <div class="col-xs-6">
        <div class="pull-right">
            <app-forward-button class="button-forward" [isLoading]="loaderStatus.isLoading" (click)="onSubmit()">
                NEXT
            </app-forward-button>
        </div>
    </div>
</div>
</div>
